<template>
  <div class="record-container">
    <home-nav-bar>
      <template #right>
        <van-button icon="plus" class="head-create" @click="createFarmWorkRecord">
          添加农事
        </van-button>
      </template>
    </home-nav-bar>
    <wh-mobile-list
      ref="farmWorkRecordList"
      class="farm-work-record-list"
      data-src="/api/getFarmWorkRecords"
    >
      <template v-slot="{list}">
        <van-swipe-cell v-for="(item,key) in list" :key="key">
          <farm-work-record-item :item="item" @click.native="editFarmWorkRecord(item)" />
          <template #right>
            <van-button text="删除" type="danger" class="delete-button" @click.native="deleteFarmWorkRecord(item)" />
          </template>
        </van-swipe-cell>
      </template>
    </wh-mobile-list>
    <farm-work-record-popup
      :visible.sync="popup.farmWork.visible"
      :init-form-data="popup.farmWork.initFormData"
      :form-type="popup.farmWork.formType"
      @submitFormSuccess="submitFormSuccessfn"
    />
  </div>
</template>

<script>
import api from '@/api'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import FarmWorkRecordItem from '@/views/productManage/PlotDetail/FarmWorkRecord/FarmWorkRecordItem'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import FarmWorkRecordPopup from '@/views/productManage/components/FarmWorkRecordPopup'
export default {
  name: 'Agricultural',
  components: { FarmWorkRecordPopup, WhMobileList, FarmWorkRecordItem, HomeNavBar },
  data() {
    return {
      popup: {
        farmWork: {
          visible: false,
          initFormData: {},
          formType: 'create'
        }
      }
    }
  },
  methods: {
    createFarmWorkRecord() {
      this.popup.farmWork.visible = true
      this.popup.farmWork.formType = 'create'
    },
    editFarmWorkRecord(item) {
      this.popup.farmWork.visible = true
      this.popup.farmWork.formType = 'edit'
      this.popup.farmWork.initFormData = item
    },
    submitFormSuccessfn(flag = true) {
      if (flag) {
        this.$refs.farmWorkRecordList.onRefresh()
      }
    },
    deleteFarmWorkRecord(item) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        api.deleteFarmWorkRecords({ id: item.id }).then(res => {
          this.$toast.success(res.msg)
          this.submitFormSuccessfn()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang='less' scoped>
.record-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.head-create {
  border: none;
  padding: 0;
  color: @primary-color;
}
.delete-button{
  height: 100%;
}
.farm-work-record-list {
  padding-top: 10px;
}
</style>
